import React, { useEffect } from 'react';
import { withAppContext } from '@ctsu/loader';
import { compose, withHandlers, withState } from 'recompose';
import atoms from 'ctsutheme/components/atoms';
import { MUITextBox, ValidatorForm } from 'components/FormHelpers/FormInputs';
import { openConfirmation } from 'helpers/Confirmation';
import _ from 'lodash';
import { GetFromCtxValue, getEmptyValue } from 'helpers';
import { FormViewContent } from 'components/FormViewContent';
import PropTypes from 'prop-types';
import { CTSUCardActions } from 'components';

const { Divider } = atoms;

const Editcontact = props => {
  const {
    contact,
    state,
    handleChange,
    closeContact,
    saveContact,
    setState,
    clearContact
  } = props;

  useEffect(() => {
    setState({
      ...contact
    });

    ValidatorForm.addValidationRule('checkPhoneNumber', value => {
      const patt1 = /^[^0-9]?([0-9]{3})[^0-9]?[^0-9]?([0-9]{3})[^0-9]?([0-9]{4})$/;
      const patt2 = /^[^0-9]?([0-9]{3})[^0-9]?[^0-9]?([0-9]{3})[^0-9]?([0-9]{4})[^0-9]?(?:([^0-9]{1,3})[^0-9]?([0-9]{3,6}))$/;
      return patt1.test(value) || patt2.test(value);
    });
  }, [contact, setState]);

  return (
    <ValidatorForm onSubmit={saveContact}>
      <FormViewContent
        primaryText="Name"
        secondaryText={(
          <MUITextBox
            title="Name"
            withRequiredValidator
            onChange={handleChange}
            error={!state.name}
            name="name"
            value={getEmptyValue(state.name)}
            validators={['required', 'maxStringLength:40']}
            placeholder="Enter Name"
            errorMessages={['Name is required', 'Name should not exceed 40 characters']}
          />
        )}
      />
      <Divider />
      <FormViewContent
        primaryText="Phone"
        secondaryText={(
          <MUITextBox
            title="Phone"
            onChange={handleChange}
            name="phone"
            placeholder="Enter Phone Number"
            value={getEmptyValue(state.phone)}
            validators={state.phone ? ['checkPhoneNumber'] : []}
            errorMessages={['Phone number is not valid']}
          />
        )}
      />
      <Divider />
      <FormViewContent
        primaryText="Email"
        secondaryText={(
          <MUITextBox
            title="Email"
            onChange={handleChange}
            placeholder="Enter Email"
            name="email"
            // error={state.email ? false : true}
            value={getEmptyValue(state.email)}
            validators={state.email ? ['isEmail', 'maxStringLength:50'] : []}
            errorMessages={[
              'Email is not valid',
              'Email should not exceed 50 characters'
            ]}
          />
        )}
      />
      <Divider />
      <CTSUCardActions
        clearClick={clearContact}
        cancelClick={closeContact}
        disabled={_.isEqual(state, contact)}
      />
    </ValidatorForm>
  );
};

Editcontact.propTypes = {
  contact: PropTypes.oneOfType([PropTypes.object]),
  state: PropTypes.oneOfType([PropTypes.object]),
  handleChange: PropTypes.func,
  closeContact: PropTypes.func,
  saveContact: PropTypes.func,
  setState: PropTypes.func,
  clearContact: PropTypes.func
};

Editcontact.defaultProps = {
  contact: null,
  state: null,
  handleChange: null,
  closeContact: null,
  saveContact: null,
  setState: null,
  clearContact: null
};

const EditContact = compose(
  withState('state', 'setState', {}),
  withHandlers({
    clearContact: props => event => {
      const { setState, contact } = props;
      setState({ ...contact });
    },
    handleChange: props => event => {
      const { state, setState } = props;
      state[event.target.name] = event.target.value ? event.target.value : '';
      setState(state);
    },
    saveContact: props => event => {
      const { state, onSaveContact, context } = props;
      const confirmEdit = () => {
        onSaveContact({
          ...state
        });
      };
      openConfirmation({
        message: GetFromCtxValue(context, 'PROTOCOL_CONTACT_CONFIMATION_SUCCESS'),
        onAction: confirmEdit,
        name: 'confirm'
      });
    }
  })
)(Editcontact);

export default withAppContext(EditContact);
